'use client'

import { useContext } from 'react'

import cn from 'clsx'
import { Button } from '@/components/Button/Button'
import { IndicatorDots } from '@/components/indicator-dots/indicator-dots'
import { ThemeContext } from '@/utils/themeContext'
import { ChevronLeft, ChevronRight } from '@doist/icons/brand'

import css from './Carousel.module.css'

export interface CarouselControlsProps {
    dotIndicatorLabels: string[]
    onChange: (value: number | 'previous' | 'next') => void
    activeIndex?: number
    sideButtons?: boolean
    variant?: 'image' | 'testimonial'
    previousButtonLabel: string
    nextButtonLabel: string
}
export function CarouselControls({
    dotIndicatorLabels,
    onChange,
    sideButtons = true,
    activeIndex = 0,
    previousButtonLabel = 'Previous',
    nextButtonLabel = 'Next',
}: CarouselControlsProps) {
    const { theme = 'todoist' } = useContext(ThemeContext)

    return (
        <div className={cn(css.controls, css[theme])}>
            {sideButtons && (
                <Button
                    className={cn(css.sideButton, css.previousButton)}
                    variant="secondary"
                    size="large"
                    startIcon={ChevronLeft}
                    onClick={() => onChange('previous')}
                    title={previousButtonLabel}
                    aria-label={previousButtonLabel}
                />
            )}

            <IndicatorDots
                className={css.dots}
                onSelectIndex={onChange}
                labels={dotIndicatorLabels}
                activeIndex={activeIndex}
            />

            {sideButtons && (
                <Button
                    className={cn(css.sideButton, css.nextButton)}
                    variant="secondary"
                    size="large"
                    startIcon={ChevronRight}
                    onClick={() => onChange('next')}
                    title={nextButtonLabel}
                    aria-label={nextButtonLabel}
                />
            )}
        </div>
    )
}
